(function () {
    'use strict';

    angular.module('app.application', [
        'app.core',
        'app.application.role'
    ]);
})();
